module.exports = __webpack_public_path__ + "70ecac4f4da7866e8c085d1756e55204.png";